
export default () => ({
    user: null
})